import { T_OFFLINE_OVERLAY_PAGE_CONSTANTS } from './TYPES'

const FR_OFFLINE_OVERLAY_PAGE_CONSTANTS: T_OFFLINE_OVERLAY_PAGE_CONSTANTS = {
  OFFLINE_TITLE: 'Pas de connexion Internet',
  OFFLINE_DESCRIPTION:
    "Vérifie bien ta connexion Internet pour pouvoir continuer à utiliser l'application."
}

export default FR_OFFLINE_OVERLAY_PAGE_CONSTANTS
